import { merge } from 'lodash-es';

/**
 * i18n 유틸리티 함수
 */

/**
 * flat 객체를 중첩된 객체로 변환
 * 예: { 'a.b.c': 'value' } -> { a: { b: { c: 'value' } } }
 */
export function toNested(obj: Record<string, string>): Record<string, any> {
    const result: Record<string, any> = {};
    for (const key in obj) {
        const keys = key.split('.');
        let current = result;
        for (let i = 0; i < keys.length; i++) {
            if (i === keys.length - 1) {
                current[keys[i]] = obj[key];
            } else {
                if (!current[keys[i]]) {
                    current[keys[i]] = {};
                }
                current = current[keys[i]];
            }
        }
    }
    return result;
}

/**
 * packages/* 공통 컴포넌트 문구에 cue 문구를 덮어 런타임 사전을 만든다.
 * packages.* 원본은 allibee 번역(lib/locales)이다 — cue 쪽에 같은 키가 있으면 cue 값이 이긴다.
 */
export function withAllibeePackages(allibeePackages: Record<string, unknown>, cueMessages: Record<string, any>): Record<string, any> {
    return merge({}, { packages: allibeePackages }, cueMessages);
}
